import React from 'react';
import FoundUsersTableRow from './FoundUsersTableRow.mjs';
import './FoundUsersTable.css';

export default function FoundUsersTable({found_users, send_invite}) 
{
    if (!found_users) return null; 

    return (
        <>
            <table id="found-users-table" class="table table-warning table-striped mt-1">
                <thead>
                    <tr>
                        <th scope="col">Name</th>
                        <th scope="col">UserName</th>
                        <th scope="col">Phone/Email</th>
                        <th scope="col"></th>
                    </tr>
                </thead>
                <tbody class="table-group-divider">
                    { found_users?.map( (found_user, i) => ( <FoundUsersTableRow found_user={found_user} send_invite={send_invite} key={i} /> )) }
                </tbody>
            </table>
        </>
    );
}
